export default __webpack_public_path__ + "static/media/About_C_Mobile.021afbe0.png";